export default __webpack_public_path__ + "static/media/fifa2-bg.87721057.jpg";